const amountOfPinnedTaskMessagesOnPage = 100;

export default amountOfPinnedTaskMessagesOnPage;
